<template>
  <v-card id="goods" elevation="0" class="mx-auto secondary">
    <v-row no-gutters class="pt-2">
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 2 : 1" class="px-2">
        <v-text-field
          v-model="cll"
          label="Antal"
          placeholder="0,00"
          :disabled="!cllEditable"
          :rules="cllRules"
          required
          outlined
          dense
          color="primary"
          background-color="white"
          @blur="updateCll"
          @focus="$event.target.select()"
        ></v-text-field>
      </v-col>
      <v-col
        :cols="this.$vuetify.breakpoint.smAndDown ? 6 : 3"
        class="px-2"
        v-if="unitTypeVisible"
      >
        <v-select
          v-model="unitType"
          :items="unitTypes"
          item-text="name"
          item-value="id"
          label="Enhedstype"
          no-data-text="Ingen enhedstyper tilgængelige"
          outlined
          dense
          color="primary"
          background-color="white"
          @change="calculateWeight"
          return-object
          :menu-props="{ contentClass: 'combobox-styled', nudgeBottom: 30 }"
        ></v-select>
      </v-col>
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2" class="px-2">
        <v-combobox
          v-model="weight"
          label="Total vægt"
          suffix="kg"
          placeholder="0,00"
          :disabled="!weightEditable"
          :rules="weightRules"
          required
          outlined
          dense
          color="primary"
          background-color="white"
          :items="weightIntervals"
          @blur="updateWeight"
          @focus="$event.target.select()"
          return-object
          :menu-props="{ contentClass: 'combobox-styled' }"
        ></v-combobox>
      </v-col>
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6" class="px-2">
        <v-row no-gutters>
          <v-col
            :cols="
              this.$vuetify.breakpoint.smAndDown ? 12 : allowRemove ? 11 : 12
            "
          >
            <v-text-field
              v-model="localdescription"
              label="Godsbeskrivelse"
              placeholder="Beskrivelse af gods"
              :disabled="!descriptionEditable"
              :rules="descriptionRules"
              required
              outlined
              dense
              color="primary"
              background-color="white"
              @blur="setDescription"
            ></v-text-field>
          </v-col>
          <v-col
            v-show="allowRemove"
            :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 1"
            :class="this.$vuetify.breakpoint.smAndDown ? 'pb-2' : 'pb-7'"
            :style="
              this.$vuetify.breakpoint.smAndDown
                ? 'text-align:center'
                : 'text-align:right'
            "
            align-self="center"
          >
            <v-tooltip bottom slot="append-outer" color="info">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  style="pointer-events: auto;"
                  @click="removeGoods(goods)"
                  class="navigation-icon"
                >
                  {{ removeIcon }}
                </v-icon>
              </template>
              <span>
                Slet gods
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div
      v-if="
        dimensionsVisible ||
          referenceVisible ||
          pipesVisible ||
          adrVisible ||
          slvVisible ||
          displayExtraInfo
      "
    >
      <v-row no-gutters>
        <v-col cols="12" class="pa-2">
          <v-icon
            color="accent"
            @click="displayExtraInfo = !displayExtraInfo"
            style="cursor:pointer;"
          >
            {{ !displayExtraInfo ? openDisplayIcon : closeDisplayIcon }}
          </v-icon>
          <b>
            Flere oplysninger
          </b>
        </v-col>
      </v-row>
      <div v-if="displayExtraInfo">
        <v-row no-gutters v-if="dimensionsVisible">
          <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 4">
            <v-row no-gutters>
              <v-col cols="4" class="px-2">
                <v-text-field
                  v-model="length"
                  label="Længde"
                  suffix="cm"
                  placeholder="0"
                  :rules="pipes ? lengthRules : []"
                  :required="pipes"
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-text-field
                  v-model="width"
                  label="Bredde"
                  suffix="cm"
                  placeholder="0"
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-text-field
                  v-model="height"
                  label="Højde"
                  suffix="cm"
                  placeholder="0"
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2">
            <v-row no-gutters>
              <v-col cols:12 class="px-2">
                <v-text-field
                  v-model="cbm"
                  label="m³"
                  suffix="m³"
                  placeholder="0,00"
                  @blur="updateCbm"
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                >
                  <v-tooltip bottom slot="append-outer" color="info">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        color="info"
                        style="pointer-events: auto;"
                      >
                        {{ helpIcon }}
                      </v-icon>
                    </template>
                    <span>
                      {{ dimensionHelpText }}
                    </span>
                  </v-tooltip>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row no-gutters v-if="referenceVisible">
          <v-col
            :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
            class="px-2"
          >
            <v-text-field
              v-model="reference"
              label="Godsreference"
              outlined
              dense
              color="primary"
              background-color="white"
              :required="!allowEmptyGoodsReference"
              :rules="!allowEmptyGoodsReference ? referenceRules : []"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="pipesVisible">
          <v-col cols="12" class="px-2">
            <v-checkbox v-model="pipes" label="Rør"></v-checkbox>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="adrVisible">
          <v-col
            :cols="this.$vuetify.breakpoint.smAndDown ? 3 : 1"
            class="px-2"
          >
            <v-checkbox v-model="adr" label="ADR"></v-checkbox>
          </v-col>
          <v-col
            :cols="this.$vuetify.breakpoint.smAndDown ? 3 : 1"
            class="px-2"
          >
            <v-text-field
              v-model="un_no"
              :disabled="!adr"
              label="UN-nr."
              :rules="adr ? unNoRules : []"
              :required="adr"
              outlined
              dense
              color="primary"
              background-color="white"
            >
            </v-text-field>
          </v-col>
          <v-col
            :cols="this.$vuetify.breakpoint.smAndDown ? 3 : 2"
            class="px-2"
          >
            <v-select
              v-model="packing_group"
              :items="packingGroups"
              label="Emballagegruppe"
              :disabled="!adr"
              :rules="adr ? packingGroupRules : []"
              :required="adr"
              outlined
              dense
              color="primary"
              background-color="white"
              :menu-props="{ contentClass: 'combobox-styled', nudgeBottom: 30 }"
            >
              <v-tooltip bottom slot="append-outer" color="info">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="info" style="pointer-events: auto;">
                    {{ helpIcon }}
                  </v-icon>
                </template>
                <span>
                  {{ adrHelpText }}
                </span>
              </v-tooltip>
            </v-select>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="slvVisible">
          <v-col cols="12" class="px-2">
            <v-row no-gutters>
              <v-checkbox v-model="slv" label="SLV">
                <v-tooltip bottom slot="append" color="info">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      color="info"
                      style="pointer-events: auto;"
                    >
                      {{ helpIcon }}
                    </v-icon>
                  </template>
                  <span>
                    {{ slvHelpText }}
                  </span>
                </v-tooltip>
              </v-checkbox>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-card>
</template>

<script>
import { tools } from "../helpers";
import { dictionary } from "../helpers";

export default {
  props: ["goods"],
  created() {
    this.unitTypeVisible = !this.$store.getters["user/hideGoodsUnitType"];
    this.dimensionsVisible = !this.$store.getters["user/hideGoodsDimensions"];
    this.referenceVisible = !this.$store.getters["user/hideGoodsReference"];
    this.allowEmptyGoodsReference = this.$store.getters[
      "user/allowEmptyGoodsReference"
    ];

    if (!this.allowEmptyGoodsReference) {
      this.displayExtraInfo = true;
    }

    this.pipesVisible = !this.$store.getters["user/hideGoodsPipes"];
    this.adrVisible = !this.$store.getters["user/hideGoodsADR"];
    this.slvVisible = !this.$store.getters["user/hideGoodsSLV"];
    const defaultCll = this.$store.getters["user/defaultGoodsCll"];
    const defaultUnitType = this.$store.getters["user/defaultGoodsUnitType"];
    const defaultWeight = this.$store.getters["user/defaultGoodsWeight"];
    const defaultDescription = this.$store.getters[
      "user/defaultGoodsDescription"
    ];

    if (
      (defaultCll &&
        tools.parseDouble(defaultCll) !== 0.0 &&
        !this.goods.cll) ||
      tools.parseDouble(this.goods.cll) === 0.0
    ) {
      this.goods.cll = defaultCll;
    }

    if (defaultUnitType) {
      this.goods.unit_type = defaultUnitType;
    }

    if (
      (defaultWeight &&
        tools.parseDouble(defaultWeight) !== 0.0 &&
        !this.goods.weight) ||
      tools.parseDouble(this.goods.weight) === 0.0
    ) {
      this.goods.weight = defaultWeight;
    }
    if (defaultDescription && !this.goods.description) {
      this.goods.description = defaultDescription;
    }
    this.localdescription = this.goods.description;
  },
  data: () => ({
    cllEditable: true,
    cllRules: [
      v => {
        if (!!v && !isNaN(parseFloat(v)) && tools.parseDouble(v) > 0)
          return true;
        return false;
      }
    ],
    unitTypeVisible: true,
    weightIntervals: [
      { text: "1,00-5,00", value: "5,00" },
      { text: "6,00-10,00", value: "10,00" },
      { text: "11,00-15,00", value: "15,00" },
      { text: "16,00-20,00", value: "20,00" },
      { text: "21,00-25,00", value: "25,00" },
      { text: "26,00-50,00", value: "50,00" },
      { text: "51,00-100,00", value: "100,00" },
      { text: "101,00-", value: "500,00" }
    ],
    descriptionEditable: true,
    descriptionRules: [v => !!v || false],
    displayExtraInfo: false,
    openDisplayIcon: dictionary.mdi.open,
    closeDisplayIcon: dictionary.mdi.close,
    lengthRules: [
      v => {
        if (!!v && !isNaN(parseFloat(v)) && tools.parseDouble(v) > 0)
          return true;
        return false;
      }
    ],
    weightEditable: true,
    weightRules: [
      v => {
        const val = typeof v == "object" ? v.value : v;
        if (!!val && !isNaN(parseFloat(val)) && tools.parseDouble(val) > 0)
          return true;
        return false;
      }
    ],
    dimensionsVisible: true,
    referenceVisible: true,
    allowEmptyGoodsReference: true,
    referenceRules: [v => !!v || false],
    pipesVisible: true,
    adrVisible: true,
    unNoRules: [v => !!v || false, v => /^\d{4}$/.test(v) || "4 cifre"],
    packingGroups: [
      { text: "I", value: "I" },
      { text: "II", value: "II" },
      { text: "III", value: "III" }
    ],
    packingGroupRules: [v => !!v || false],
    slvVisible: true,
    helpIcon: dictionary.mdi.help,
    dimensionHelpText: dictionary.help.dimension,
    adrHelpText: dictionary.help.adr,
    slvHelpText: dictionary.help.slv,
    removeIcon: dictionary.mdi.remove,
    localdescription: ""
  }),
  computed: {
    cll: {
      get() {
        return this.goods.cll;
      },
      set(value) {
        this.goods.cll = value;
      }
    },
    unitTypes() {
      return this.$store.getters["user/unitTypes"];
    },
    unitType: {
      get() {
        return this.goods.unit_type;
      },
      set(value) {
        this.goods.unit_type = value;
      }
    },
    description: {
      get() {
        return this.goods.description;
      },
      set(value) {
        this.goods.description = value;
      }
    },
    weight: {
      get() {
        const weight = this.goods.weight;
        let matchingWeightInterval = null;

        this.weightIntervals.forEach(weightInterval => {
          if (weightInterval && weightInterval.value == weight) {
            matchingWeightInterval = weightInterval;
          }
        });

        return matchingWeightInterval ? matchingWeightInterval : weight;
      },
      set(value) {
        if (typeof value == "object") {
          value = value.value;
        }
        this.goods.weight = value;
      }
    },
    length: {
      get() {
        return this.goods.length;
      },
      set(value) {
        this.goods.length = value;
        this.calculateCbm();
      }
    },
    width: {
      get() {
        return this.goods.width;
      },
      set(value) {
        this.goods.width = value;
        this.calculateCbm();
      }
    },
    height: {
      get() {
        return this.goods.height;
      },
      set(value) {
        this.goods.height = value;
        this.calculateCbm();
      }
    },
    cbm: {
      get() {
        return this.goods.cbm;
      },
      set(value) {
        this.goods.cbm = value;
      }
    },
    reference: {
      get() {
        return this.goods.reference;
      },
      set(value) {
        this.goods.reference = value;
      }
    },
    pipes: {
      get() {
        return this.goods.pipes;
      },
      set(value) {
        this.goods.pipes = value;
      }
    },
    adr: {
      get() {
        return this.goods.adr;
      },
      set(value) {
        this.goods.adr = value;
        if (!this.goods.adr) {
          this.goods.un_no = "";
        }
        this.calculatePrice();
      }
    },
    un_no: {
      get() {
        return this.goods.un_no;
      },
      set(value) {
        this.goods.un_no = value;
      }
    },
    packing_group: {
      get() {
        return this.goods.packing_group;
      },
      set(value) {
        this.goods.packing_group = value;
      }
    },
    slv: {
      get() {
        return this.goods.slv;
      },
      set(value) {
        this.goods.slv = value;
      }
    },
    allowRemove() {
      return this.$store.state.booking.data.goods.length > 1;
    }
  },
  watch: {
    description() {
      this.localdescription = this.description;
    }
  },
  methods: {
    removeGoods(goods) {
      this.$store.commit("booking/removeGoods", goods);
    },
    updateCll() {
      this.goods.cll = tools.parseDoubleToString(
        tools.parseDouble(this.goods.cll)
      );
      this.calculateWeight();
    },
    calculateWeight() {
      const cll = tools.parseDouble(this.goods.cll);
      if (
        cll > 0 &&
        this.goods.unit_type &&
        this.goods.unit_type.calculation_factor_kg &&
        this.goods.unit_type.calculation_factor_kg > 0
      ) {
        this.goods.weight = tools.parseDoubleToString(
          cll * tools.parseDouble(this.goods.unit_type.calculation_factor_kg)
        );
        this.calculatePrice();
      }
    },
    updateWeight() {
      this.goods.weight = tools.parseDoubleToString(
        tools.parseDouble(this.goods.weight)
      );
      this.calculatePrice();
    },
    calculateCbm() {
      const cbm =
        ((((this.goods.length / 100) * this.goods.width) / 100) *
          this.goods.height) /
        100;
      this.goods.cbm = tools.parseDoubleToString(cbm);
    },
    updateCbm() {
      this.goods.cbm = tools.parseDoubleToString(
        tools.parseDouble(this.goods.cbm)
      );
    },
    calculatePrice() {
      this.$store.dispatch("booking/calculatePrice");
    },
    setDescription() {
      this.goods.description = this.localdescription;
    }
  }
};
</script>
